import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "react-feather";
import { MAROON } from "../../../components/common/brandColors";

// Same brand-maroon collapsible-header language as PermissionChecklist.jsx
// (feedback_react_permission_ui_pattern) - #6E1423 header strip, explicit
// inline #fff on every child (this app's theme CSS overrides inherited
// link/button color, so relying on `color: inherit` silently loses it),
// white pill badges for the header's own key facts instead of a plain
// dot-joined string.
export { MAROON };

// Generic collapsible "Linked Documents" card - each item is a maroon
// summary strip (icon + title + fact chips) collapsed by default, expanding
// to `detail` on click. This component only owns the collapse chrome; each
// caller (LpoDetail today - Vehicle Maintenance Request / Quotation links)
// supplies its own title/chips/detail content. `icon` is a react-feather
// icon component (not an element) so this component can force its color to
// white itself, same reasoning as the inline #fff above. Each chip is
// `{ label, icon }` (icon optional, also a react-feather component) so a
// reg no/model/date/amount chip each carry their own little type marker
// instead of reading as identical interchangeable pills.
const LinkedDocumentsPanel = ({ items = [] }) => {
  const [expandedKey, setExpandedKey] = useState(null);

  if (items.length === 0) return null;

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h5 className="mb-3">Linked Documents</h5>
        {items.map((item) => {
          const isOpen = expandedKey === item.key;
          const Icon = item.icon;
          return (
            <div key={item.key} className="rounded mb-2 overflow-hidden">
              <button
                type="button"
                className="btn w-100 text-start d-flex align-items-center gap-2 flex-wrap"
                style={{ background: MAROON, border: "none", padding: "12px 16px" }}
                onClick={() => setExpandedKey(isOpen ? null : item.key)}
              >
                {isOpen ? <ChevronDown size={18} color="#fff" /> : <ChevronRight size={18} color="#fff" />}
                <span
                  className="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                  style={{ width: 32, height: 32, background: "rgba(255,255,255,0.2)" }}
                >
                  <Icon size={17} color="#fff" />
                </span>
                <span className="fw-semibold" style={{ color: "#fff", fontSize: 16 }}>{item.title}</span>
                <span className="d-flex flex-wrap gap-2 ms-auto">
                  {item.chips.map((chip, idx) => {
                    const { label, icon: ChipIcon } = typeof chip === "string" ? { label: chip } : chip;
                    return (
                      <span
                        key={idx}
                        className="badge rounded-pill d-inline-flex align-items-center gap-1"
                        style={{ background: "#fff", color: MAROON, fontSize: 13, padding: "6px 12px" }}
                      >
                        {ChipIcon && <ChipIcon size={12} color={MAROON} />}
                        {label}
                      </span>
                    );
                  })}
                </span>
              </button>
              {isOpen && (
                <div className="rounded-bottom px-3 py-3" style={{ background: "#FFF9FA", border: `1px solid ${MAROON}`, borderTop: "none" }}>
                  {item.detail}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LinkedDocumentsPanel;
